import {
    ModuleWithProviders,
    NgModule,
} from '@angular/core';
import {
    PageCategory,
    PageScope,
    providePageMeta,
} from '@app/router';

@NgModule()
export class SettingsMetaModule {
    static forRoot(): ModuleWithProviders {
        return {
            ngModule: SettingsMetaModule,
            providers: [
                providePageMeta({
                    title: 'Settings',
                    translationKey: 'page_settings',
                    routerLink: '/settings',
                    icon: 'settings',
                    permission: 'Settings.View',
                    type: 'Admin',
                    category: PageCategory.Tenant,
                    scope: PageScope.Global,
                    priority: 0,
                }),
            ],
        };
    }
}
